import { objectToBase64 } from '@lib/utils';

const getImgUrlFromKeyIamLogin = (key: string, transforms: any = {}) => {
  const q = objectToBase64(transforms);

  return `/login/img/${key}?q=${q}`;
};

const getImgUrlFromKey = (key: string, transforms: any = {}) => {
  const q = objectToBase64(transforms);

  return `/img/${key}?q=${q}`;
};

const getKeyFormS3Url = (url: string) => {
  const parts = (url.split('//')[1] as string)?.split('/');

  const key = parts[2]?.split('?')[0];

  // TODO fix this fallback
  if (!key) {
    return '/static/not-found.png';
  }

  return key;
};

const getImgUrlFromS3Url = (url: string, transforms: any = {}) => {
  const q = objectToBase64(transforms);
  const key = getKeyFormS3Url(url);

  return `/img/${key}?q=${q}`;
};

const imageService = {
  getImgUrlFromKey,
  getKeyFormS3Url,
  getImgUrlFromS3Url,
  getImgUrlFromKeyIamLogin
};

export { imageService as image };
